export default {
  contract: {
    agreement_violation: {
      headline: "§12. Misligholdelse af aftalen",
      paragraph_one:
        "12.1.\tSåfremt den ene af Parterne misligholder sine forpligtelser efter denne Aftale, skal den anden part påtale forholdet skriftligt og give den misligholdende part en passende tid – dog minimum 30 dage - til at opfylde Aftalen. Hvis kontrakten ikke bliver opfyldt efter skriftlig påtale, betragtes dette som en væsentlig misligholdelse, og Aftalen kan herefter opsiges uden varsel.",
      paragraph_two:
        "12.2.\tAftalen kan dog opsiges uden skriftlig påtale og uden varsel, såfremt misligholdelsen er væsentlig og der ikke kan ske afhjælpning.",
      paragraph_three:
        "12.3.\tFølgende skal altid betragtes som væsentlig misligholdelse af Aftalen, således at Leverandøren ved Distributørens overtrædelse heraf, kan ophæve Aftalen uden varsel, forudsat at der er sket korrekt levering:",
      paragraph_three_listings: {
        one: "Manglende overholdelse af evt. aftalte salgsmål, jf. § 4.5",
        two: "Manglende overholdelse af konkurrenceklausul, jf. § 4.7.",
        three:
          "Manglende overholdelse af hemmeligholdelsesbestemmelsen, jf. § 10.",
        four: "Manglende overholdelse af § 15.",
        five: "Manglende overholdelse af Leverandørens betalingsbetingelser.",
        six:
          "Distributøren tages under en rekonstruktions- eller konkursbehandling som medfører, at Distributøren efter al sandsynlighed ikke vil kunne opfylde nærværende Aftale.",
      },
    },
    appendix: {
      headline: "§18. Aftalens bilag",
      paragraph_one: "Følgende bilag er vedlagt denne Aftale:",
      paragraph_one_listing: {
        one:
          "<b>Bilag 1</b> - Kunder Leverandøren er berettiget til at sælge til direkte, jf. § 3.2.",
        two: "<b>Bilag 2</b> - Template til standardrapportering, jf. § 4.4.",
        three:
          "<b>Bilag 3</b> - De for Distributøren gældende engrospriser, jf. § 5.1. ",
        four:
          "<b>Bilag 4</b> - Leverandørens salgs- og leveringsbetingelser, jf. § 9.1. ",
      },
    },
    background: {
      headline: "§1. Baggrund",
      paragraph_one:
        "1.1.\tLeverandøren overdrager til Distributøren retten til at købe og videresælge Leverandørens Produkter i et bestemt område.",
      paragraph_two:
        "1.2.\tDistributøren køber og videresælger Produkterne i eget navn og for egen regning.",
      paragraph_three:
        "1.3.\tParterne skal under udøvelsen af deres hverv handle loyalt og redeligt over for hinanden og over for tredjemand. De skal opfylde deres pligter i overensstemmelse med god forretningsskik.",
      paragraph_four:
        "1.4.\tParterne må ikke ubeføjet viderebringe eller benytte erhvervshemmeligheder, som de har fået kendskab til under Aftaleperioden.",
    },
    duration_and_resignation: {
      headline: "§11. Aftalens løbetid og opsigelse",
      unlimited: {
        paragraph_one: "Aftalen er indgået på ubestemt tid.",
        paragraph_two:
          "Hver af Parterne kan opsige Aftalen med 6 (seks) måneders varsel til udgangen af en kalendermåned.",
        paragraph_three:
          "Opsiger Leverandøren samarbejdet tidligere end med virkning fra den {date}, er Leverandøren forpligtet til at erstatte Distributøren 50 % af de dokumenterede, og af ham inden den nævnte dato endeligt afholdte markedsføringsomkostninger i relation til Produkterne. Endvidere er Leverandøren forpligtet til at refundere Distributøren 50 % af de af Distributøren afholdte lønomkostninger, der dokumenterbart relaterer sig til salget og markedsføringen af de af Aftalen omfattede Produkter. Det samme gælder vedrørende Distributørens evt. bygningsmæssige investeringer til opfyldelse af nærværende kontrakt, såfremt Leverandøren på forhånd er blevet orienteret om disse tiltag.",
        paragraph_four:
          "Ved opsigelse med virkning efter nævnte dato gælder ovenstående bestemmelse ikke. Bestemmelsen gælder endvidere ikke, såfremt 1) Leverandøren bringer Aftalen til ophør på grund af Distributørens væsentlige misligholdelse af Aftalen. 2) Aftalen opsiges af Distributøren, medmindre at opsigelsen skyldes Leverandørens misligholdelse af Aftalen.",
      },
      limited_auto_renew: {
        paragraph_one:
          "Aftalen træder i kraft den {fromDate} og vil for begge parter være uopsigelig frem til den {toDate}. Opsiges Aftalen ikke med 1 måneds varsel af en af Parterne til udløb af uopsigelighedsperioden, forlænges Aftalen automatisk og vil herefter af hver Part kunne opsiges med 6 måneders varsel kunne opsiges med 6 måneders varsel.",
      },
      limited: {
        paragraph_one:
          "Aftalen træder i kraft den {fromDate} og gælder frem til den {toDate} (”Aftaleperioden”) hvorefter Aftalen ophører uden varsel. Aftalen er dermed uopsigelig i Aftaleperioden og kan alene bringes til ophør i Aftaleperioden såfremt en Part væsentlig misligholder Aftalen.",
      },
      placeholder: {
        date: "[dato]",
        period: "[periode]",
      },
    },
    goodwill: {
      headline: "§13. Godtgørelse for goodwill",
      not_relevant_text:
        "Distributøren er ikke berettiget til goodwill-godtgørelse i anledning af Aftalens ophør.",
      paragraph_one:
        "13.1.\tOpsiges Aftalen af Leverandøren, skal Leverandøren betale Distributøren en goodwill-erstatning, medmindre Leverandøren bringer Aftalen til ophør på grund af Distributørens væsentlige misligholdelse af Aftalen.",
      paragraph_two:
        "13.2.\tGodtgørelsen udgør {percent} % af et års omsætning hos Distributøren med de af Aftalen omfattede Produkter beregnet som den gennemsnitlige årsomsætning i de forudgående 5 år eller, såfremt Aftalen har været i kraft i mindre end 5 år, Distributørens omsætning i kontraktperioden. Alene Distributørens omsætning med de af ham skaffede nye kunder henholdsvis den forøgede omsætning med Leverandørens på tidspunktet for Aftalens indgåelse allerede bestående kundekreds i Området medtages i opgørelsen.",
      paragraph_three:
        "13.3.\tVed betaling af goodwill-godtgørelse skal Distributøren til Leverandøren udlevere en fortegnelse over kunderne i Området, herunder hvilke kunder, der er tilført i kontraktperioden.",
      paragraph_four:
        "13.4.\tGoodwill-godtgørelsen ifølge § 13.1 og 13.2, og Leverandørens forpligtelse til at tilbagekøbe reservedele og lager, jfr. § 6, skal anses at være udtømmende erstatning for salgsaktiviteterne samt for Distributørens investeringer og omkostninger i Aftalens løbetid. {addon}",
      paragraph_four_addon:
        "§ 11.3 kan dog finde anvendelse i tillæg til § 13.1 og 13.2.",
      paragraph_five:
        "13.5.\tDistributøren kan ikke kræve kompensation for en af Distributøren oparbejdet kundekreds, som Leverandøren ikke fremover vil kunne drage fordel af.",
      placeholder: {
        percent: "[procent]",
      },
    },
    handover: {
      headline: "§15. Overdragelse af aftalen",
      paragraph_one:
        "15.1.\tDistributøren kan ikke uden forudgående aftale med Leverandøren overdrage nærværende Aftale til anden side.",
      paragraph_two:
        "15.2.\tSåfremt Distributøren driver virksomhed i selskabsform, må Distributøren ikke overdrage – eller på anden måde overlade – en bestemmende andel af kapitalandele til 3.mand.",
    },
    material_return: {
      headline: "§14. Tilbagelevering af materiale og ejendele",
      paragraph_one:
        "14.1.\tMedmindre andet er aftalt, skal Distributøren ved Aftalens ophør og for Distributørens egen regning:",
      paragraph_one_listing: {
        one:
          "Tilbagelevere alt materialer, som Leverandøren har udleveret til Distributøren, jf. § 3.3;",
        two:
          "Overdrage eventuelle e-mailadresser eller URL-adresser, hvor Leverandørens eller Produkternes navn indgår, jf. 8.3; og ",
        three:
          "Standse enhver form for markedsføring af Leverandørens produkter.",
      },
      paragraph_two:
        "14.2.\tDistributøren har ikke tilbageholdsret i Leverandørens ejendom, medmindre der foreligger endelig dom for Distributørens økonomiske krav mod Leverandøren.",
    },
    other_regulations: {
      headline: "§17. Andre bestemmelser og særlige tilføjelser",
      paragraph_one:
        "17.1.\tKun skriftlige ændringer og tilføjelser til Aftalen har retsvirkning.",
    },
    product_and_area: {
      headline: "§2. Produkter og område",
      paragraph_one:
        '2.1.\tLeverandøren overdrager Distributøren {exclusiveType} til salg af produkterne angivet i § 2.1.1 ("Produkterne") indenfor området angivet i § 2.1.2 ("Området"):',
      paragraph_one_one: "2.1.1.\tProdukterne",
      paragraph_one_two: "2.1.2.\tOmrådet",
      paragraph_two:
        "2.2.\tProdukter omfatter endvidere nye produkter, der har en nær sammenhæng med eller erstatter Produkterne.",
      paragraph_three:
        "2.3.\tLeverandøren skal tilbyde Distributøren {exclusiveType} til at sælge nye produkter, der ikke har en nær sammenhæng med eller erstatter Produkterne, under forudsætning af, at dette ikke strider mod Leverandørens forpligtelser i henhold til Aftaler, der er indgået med andre forhandlere forud for afslutningen af nærværende Aftale. Såfremt Distributøren ikke senest 14 dage fra modtagelsen af tilbuddet accepterer at markedsføre sådanne tillægsprodukter, er Leverandøren berettiget til enten selv eller ved benyttelse af andre salgskanaler, at sælge tillægsprodukterne til kunder inden for Området.",
      exclusive: "eneforhandlingsretten",
      non_exclusive: "forhandlingsretten",
    },
    patent_and_trademark: {
      headline: "§8. Patenter og varemærker",
      paragraph_one:
        "8.1\tAlle intellektuelle rettigheder vedrørende Produktet, herunder men ikke begrænset til varemærker, mønstre, ophavsrettigheder og brugsmodeller, tilhører Leverandøren og Distributøren må alene gøre brug af disse rettigheder, såfremt brugen tjener til opfyldelse af nærværende Aftale. Distributørens brug skal straks ophøre ved Aftalens ophør.",
      paragraph_two:
        "8.2\tDistributøren forpligter sig til at informere Leverandøren om enhver form for krænkelse af ovennævnte rettigheder.",
      paragraph_three:
        "8.3\tOprettelse af eventuelle hjemmesider og domænenavne, hvori Leverandørens eller Produkternes navn indgår i adresselinjen (fx URL), kan kun ske med Leverandørens forudgående skriftlige tilladelse. Registrering skal i så fald ske i Leverandørens navn. Såfremt registreringen undtagelsesvist ikke er sket i Leverandørens navn, skal alle sådanne sider og domænenavne ved Aftalens ophør overdrages til Leverandøren for Distributørens regning, jf. § 14.1.",
      paragraph_four:
        "8.3\tVed aftalens ophør skal Distributøren straks ophøre med at gøre brug af Leverandørens intellektuelle rettigheder og straks ophøre med at markedsføre sig selv som værende Leverandørens officielle repræsentant indenfor Området.",
    },
    prices: {
      headline: "§5. Priser og prisændringer",
      paragraph_one:
        "5.1\tDe for Distributøren gældende engrospriser fremgår af Aftalens <b>Bilag 3</b>. Priserne justeres årligt pr. 1. januar.",
      paragraph_two:
        "5.2\tDistributøren fastsætter selv sine videresalgspriser.",
    },
    sale_and_delivery: {
      headline: "§9. Salgs- og leveringsbetingelser",
      paragraph_one:
        "9.1\tAlle af nærværende Aftale omfattede leverancer er underlagt Leverandørens salgs- og leveringsbetingelser, der er vedlagt som <b>Bilag 4</b> og udgør en integreret del af Aftalen. I tilfælde af uoverensstemmelser mellem dokumenterne går nærværende Aftale forud.",
      paragraph_two:
        "9.2\tLeverandøren skal advisere ændringer i de nævnte salgs- og leveringsbetingelser med 2 måneders varsel.",
    },
    secrets: {
      headline: "§10. Hemmeligholdelse",
      paragraph_one:
        "10.1.\tEn Part skal bevare alle Fortrolige Oplysninger, som erhverves fra den anden Part i forbindelse med gennemførelsen af Aftalen, strengt fortroligt og må ikke uden den anden Parts forudgående skriftlige samtykke, udnytte eller videregive Fortrolige Oplysninger til tredjepart eller bruge dem til andet formål end opfyldelse af Aftalen.",
      paragraph_two:
        "10.2.\t”Fortrolige Oplysninger” betyder alle oplysninger, som en Part giver til den anden Part i forbindelse med gennemførelsen af Aftalen, og som vedrører Partens forretning, herunder, men ikke begrænset til, oplysninger om økonomi, udvikling, produktion, markedsføring, salg, kunder, leverandører, knowhow, forretningshemmeligheder og Aftalens vilkår.",
      paragraph_three:
        "10.3.\tForpligtelserne i Aftalens 10.1 gælder ikke for Fortrolige Oplysninger, der er almindeligt tilgængelige for offentligheden, opnås af en Part i god tro fra tredjepart, udvikles selvstændigt af en Part uden brug af den anden Parts Fortrolige Oplysninger eller udleveres til opfyldelse af lovmæssige forpligtelser.",
      paragraph_four:
        "10.4.\t§10 finder også anvendelse efter udløbet af denne Aftale.",
    },
    service: {
      headline: "§7. Service",
      paragraph_one:
        "7.1\tDistributøren skal kunne yde kunderne service og teknisk assistance. Distributøren er forpligtet til at udføre evt. garantireparationer efter nærmere aftale med Leverandøren. Garantireparationer, der er udført af Distributøren eller dennes underleverandør, honoreres af Leverandøren i henhold til de til enhver tid gældende retningslinjer herfor.",
      paragraph_two:
        "7.2\tLeverandøren forpligter sig til, uden omkostning for Distributøren, at bistå Distributøren med kundeservice, samt til at viderebringe nødvendig teknisk information, herunder være behjælpelig med uddannelse af Distributørens personale.",
    },
    signature: {
      headline: "§19. Underskrifter",
      signature_line: "______________________________",
      distributor_text: "For og på vegne af Distributøren",
      supplier_text: "For og på vegne af Leverandøren",
      placeholder: {
        name: "[Navn]",
        date: "[Dato]",
      },
    },
    stock: {
      headline: "§6. Lagerbeholdning",
      paragraph_one:
        "6.1\tDistributøren påtager sig at holde et rimeligt lager af Produkter og reservedele for at kunne imødekomme kundernes efterspørgsel.",
      paragraph_two:
        "6.2\tEfter Distributørens ønske er Leverandøren ved Aftalens ophør forpligtet til at tilbagekøbe alle kurante Produkter og reservedele, som Distributøren på dette tidspunkt har på lager, forudsat at disse befinder sig i original emballage. Tilbagekøbsprisen skal svare til Distributørens købspris (ifølge faktura med eventuelt tillæg af fragt, forsikringsudgifter og told). Udgifterne ved tilbageleveringen afholdes af Leverandøren.",
    },
    supplier_rights_and_obligations: {
      headline: "§3. Leverandørens rettigheder og forpligtigelser",
      paragraph_one:
        "3.1.\tLeverandøren er forpligtet til at acceptere Distributørens ordrer medmindre væsentlige grunde taler imod.",
      paragraph_two:
        "3.2.\tLeverandøren afstår fra at markedsføre og/eller sælge direkte til kunderne indenfor Området, bortset fra de kunder, der er nævnt i <b>Bilag 1</b>. Provisionsudløsende salg medfører ikke, at Distributøren opnår status som handelsagent.",
      paragraph_three:
        "Under samarbejdet er Leverandøren berettiget til at tilføje yderligere kunder til Bilag 1. Er der tale om kunder, der er skabt af Distributøren, kan dette kun ske med minimum 6 måneders varsel og mod behørig kompensation svarende til {compensationPercentage}% af Distributørens seneste 12 måneders omsætning med kunden.",
      paragraph_four:
        "Leverandøren forsyner omkostningsfrit Distributøren med alle nødvendige manualer, kollektioner, brugsanvisninger, prøver, mønstre, tegninger m.m. Dette materiale er Leverandørens ejendom og skal i tilfælde af Aftalens ophør vederlagsfrit returneres af Distributøren jf. § 14.1, medmindre Distributøren har forbrugt materialet i overensstemmelse med formålet.",
      paragraph_five:
        "Leverandøren skal tillade, at Distributøren markedsfører Produkterne på Distributørens hjemmeside. Den konkrete markedsføring – herunder brugen af Leverandørens varemærker - skal forhåndsgodkendes af Leverandøren.",
      paragraph_six:
        "Eventuelle udgifter til oversættelse af brugsanvisninger og andet salgsmateriale samt udgifter til ved lov påkrævede godkendelser/afprøvninger af Produkterne afholdes af Leverandøren.",
      placeholder: {
        compensation: "[kompensationssats]",
      },
    },
    distributor_rights_and_obligations: {
      headline: "§4. Distributørens rettigheder og forpligtigelser",
      placeholder: {
        fairs: "[antal årlige messer]",
        marketingPercent: "[procent]",
      },
      fairs: {
        singular: "en årlig messe",
        plural: "{n} årlige messer",
      },
      paragraph_one:
        "4.1\tDer kan træffes nærmere aftale om Distributørens ansvar for markedsføring, public relations og lignende i relation til Produkterne eller Leverandørens virksomhed i almindelighed, samt om fordelingen af omkostningerne herfor.",
      paragraph_two:
        "4.2\tDistributøren er forpligtet til at deltage i {yearlyFairs} i ind-og udland efter Leverandørens ønske. Udgifter til leje af stand samt Distributørens transport til messen afholdes af Leverandøren. Udgifter til kost og logi afholdes af Distributøren. Øvrige udgifter fordeles mellem Parterne efter forudgående aftale.",
      paragraph_two_no_fair:
        "4.2\tDistributøren er ikke forpligtet til at deltage i messer i ind-og udland.",
      paragraph_three:
        "4.3\tDistributøren er endvidere forpligtet til at bruge {marketingPercent} % af sin omsætning på Produkterne til markedsføringen af Produkterne i Området.",
      paragraph_four:
        "4.4\tDistributøren skal aflægge en skriftlig rapport om salgsarbejdet hvert kvartal/halve år efter Leverandøren nærmere forskrifter og skal løbende holde Leverandøren underrettet om markedsforhold og konkurrencevilkår inden for Området. Template til standardrapportering er vedlagt som <b>Bilag 2</b>.",
      paragraph_five:
        "4.5\tParterne kan aftale salgsmål. Manglende opfyldelse af salgsmål skal betragtes som væsentlig misligholdelse af Aftalen. Dette gælder dog ikke, hvis Distributøren kan godtgøre, at nedgangen i salget skyldes forhold, der ikke kan tilregnes Distributøren, og omsætningen ikke er underskredet med mere end 50 % af salgsmålet.",
      paragraph_six:
        "4.6\tManglende opfyldelse af salgsmål medfører altid, at Leverandøren enten kan reducere Distributørens Område eller fjerne Distributørens eventuelle eksklusivitet med 3 måneders varsel.",
      paragraph_seven:
        "4.7\tDistributøren forpligter sig til ikke direkte eller indirekte at være beskæftiget med markedsføring af andre produkter inden for Området, som kan antages at konkurrere med Produkterne. Nærværende klausul er gældende i 5 år. Stopper samarbejdet inden udløbet af de 5 år ophører klausulen automatisk på dagen for samarbejdets ophør.",
      paragraph_eight:
        "4.8\tDistributøren forpligter sig til ikke at reklamere, oprette filialer eller have udleveringslagre for Produkterne uden for Området. Endvidere forpligter Distributøren sig til ikke at sælge Produkterne direkte til forbrugere.",
    },
    header: {
      title_non_exclusive: "Distributøraftale",
      title_exclusive: "Eksklusiv distributøraftale",
      subtitle_supplier: "leverandørversion",
      subtitle_distributor: "distributørversion",
    },
    parties: {
      headline: "Parterne",
      placeholder: {
        name: "[Navn]",
        cvr: "[CVR-nummer]",
        address: "[Adresse]",
        zip_city: "[Postnr. og by]",
        country: "[Land]",
        date: "[dato]",
      },
      label: {
        cvr: "CVR-nr.: ",
        distributor: '("Distributøren")',
        supplier: '("Leverandøren")',
      },
      and: "og",
      intro: "Denne distributøraftale (Aftalen) er den {date} indgået mellem",
      end:
        '(Distributøren og Leverandøren kaldes tilsammen "Parterne" og hver for sig en "Part")',
    },
    venue_governing_law: {
      headline: "§16. Lovvalg - værneting",
      paragraph_one: "16.1.\tAftalen er underlagt dansk ret.",
      paragraph_two:
        "16.2.\tEnhver tvist, som måtte opstå i forbindelse med Aftalen, herunder tvister vedrørende Aftalens eksistens eller gyldighed, skal behandles af de almindelige danske domstole.",
      paragraph_two_alternate:
        "16.2.\tEnhver tvist, som måtte opstå i forbindelse med Aftalen, herunder tvister vedrørende Aftalens eksistens eller gyldighed, skal afgøres ved voldgift efter de af  det Danske Voldgiftsinstituts vedtagne regler herom.",
    },
  },
};



// WEBPACK FOOTER //
// ./src/apps/eneforhandler/translations/contract/da_contract.js